import grouper from '@/components/Form/javascripts/grouper';

const GROUPS = {
  PICTURES: { title: 'Showroom', subtitle: 'Adicione uma descrição e fotos do seu veículo' },
  INFORMATION: { title: 'Informações do veículo', subtitle: 'Dados do veículo em estoque' },
  EXTRA: { title: 'Dados adicionais', subtitle: 'Informações extras do veículo' },
};

export default grouper(GROUPS);
